(function (angular) {

    angular
        .module("app")
        .controller("cancelAccountController", ["$uibModalInstance", "$http", "Messages", "message", function ($uibModalInstance, $http, Messages, message) {
            var vm = this;

            vm.message = message;
            vm.processing = false;

            vm.ok = function () {
                vm.processing = true;

                $http.post("/api/ManageAccount/CancelCustomer")
                    .success(function () {
                        $uibModalInstance.close();
                    })
                    .error(function (err) {
                        Messages.add("danger", "Error cancelling your account.", { showOnNextPage: false });
                        $uibModalInstance.dismiss("cancel");
                    });
            };

            vm.close = function () {
                $uibModalInstance.dismiss("cancel");
            };
        }]);
})(window.angular);


// WEBPACK FOOTER //
// ./app/account/cancelAccount.controller.js